import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFConverterAppListView from "./PDFConverterAppListView";
import { BASE_URL } from "../Config";

function PDFConverterMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Converter Online Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_converter", title: "Convert PDF For Free" },
    data2: { link: "/pdf_to_image", title: "PDF To Image Converter" },
    data3: { link: "/image_to_pdf", title: "Image To PDF Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        showEditFileScreen,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF files online easily. Change PDF to Word, Excel, JPG, and more formats quickly with our fast, secure, and reliable PDF converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf converter, convert pdf, pdf to word, pdf to excel, pdf to jpg, pdf to png, pdf to ppt, word to pdf, excel to pdf, image to pdf, online pdf converter, pdf file converter, free pdf converter, pdf conversion tool, secure pdf converter, pdf to docx online, pdf to doc online, pdf to odr online, doc to pdf online, docx to pdf online, ppt to pdf online, pdf to ppt online, pptx to pdf online, pdf to pptx online, xls to pdf online, xlsx to pdf online, pdf to xlsx online, pdf to xls online, free pdf converter, pdf converter for free, download pdf converter, docuemnt converter,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* App List */}
        <PDFConverterAppListView />
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF Converter website offers a fast, secure, and reliable solution for converting files to and from PDF format without requiring an internet connection. Designed to work fully offline, this powerful tool ensures complete privacy by processing all files directly on your device, making it ideal for users who handle sensitive documents. Whether you need to convert Word to PDF, Excel to PDF, PowerPoint to PDF, images to PDF, or convert PDF to Word, Excel, JPG, or PNG, this offline PDF converter delivers high quality results with accurate formatting. The platform also supports online usage when needed, giving users flexibility while maintaining the benefits of an offline PDF converter. With a clean interface and fast conversion engine, users can easily convert documents for work, study, or business without file size limits or watermarks. Optimized for speed and compatibility, this website works across multiple devices and operating systems, making it a dependable PDF converter online alternative for secure document processing. If you are looking for a PDF converter free, a privacy focused offline PDF converter, or a simple and efficient PDF conversion tool, this website provides a complete solution for everyday document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF Converter"
          why_use={[
            {
              title: "Universal Document Conversion",
              description:
                "Our PDF converter allows you to convert Word, Excel, PowerPoint, images, and other files into PDF, a universally accepted format. Using a PDF converter online or offline ensures documents display consistently across all devices.",
            },
            {
              title: "Convert PDFs to Editable Formats",
              description:
                "With a PDF converter tool, users can easily convert PDF to Word, Excel, JPG, or PNG. This makes editing and reusing content simple without recreating documents from scratch.",
            },
            {
              title: "Offline Conversion for Data Privacy",
              description:
                "This offline PDF converter processes files directly on your device, keeping sensitive data secure. This is ideal for users who prefer not to upload documents to a PDF converter online.",
            },
            {
              title: "Time Saving and Productive",
              description:
                "This fast PDF converter free tool converts files in just a few clicks, helping professionals, students, and businesses save time and improve productivity.",
            },
            {
              title: "Preserves Original Formatting",
              description:
                "High quality PDF conversion tools maintain fonts, layouts, images, and tables during conversion. Whether converting Word to PDF or PDF to JPG, formatting remains accurate.",
            },
            {
              title: "Supports Multiple File Formats",
              description:
                "Our modern PDF converter online supports DOCX, XLSX, PPTX, JPG, PNG, and more, making it an all in one document conversion solution.",
            },
            {
              title: "Useful for Work, Study, and Business",
              description:
                "Students, professionals, and businesses rely on PDF converters to submit assignments, share reports, and manage official documents efficiently.",
            },
            {
              title: "Eliminates File Compatibility Issues",
              description:
                "Using a PDF converter free ensures files open correctly on any device or operating system, reducing compatibility problems during file sharing.",
            },
            {
              title: "Cost Effective and Easy to Use",
              description:
                "Our free PDF converter removes the need for expensive software while offering a simple interface that requires no technical expertise.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFConverterMain;
